import { TemplateVisibility } from '@heidi/schema/ml-scribe';

export const getSharedTeamIdsExcludingOrganization = (
  sharedTeamIds: readonly string[] | null | undefined,
  organizationId: string | null | undefined
): string[] => [
  ...new Set((sharedTeamIds ?? []).filter((id) => !!id && id !== organizationId)),
];

/**
 * Returns the team provenance id that should be sent with a template visibility
 * payload. Team visibility always needs a team id. Organisation visibility only
 * needs one on broad-sharing paths, where Template Managers must preserve the
 * originating team for later ownership checks.
 */
export const getTeamIdForTemplateVisibility = ({
  visibility,
  templateTeamId,
  fallbackTeamId,
  includeOrganization = true,
}: {
  visibility?: TemplateVisibility | null;
  templateTeamId?: string | null;
  fallbackTeamId?: string | null;
  includeOrganization?: boolean;
}) => {
  const shouldAttachTeamId =
    visibility === TemplateVisibility.Team ||
    (includeOrganization && visibility === TemplateVisibility.Organization);

  if (!shouldAttachTeamId) {
    return undefined;
  }

  return templateTeamId || fallbackTeamId || undefined;
};
